import {adminAxios} from '@/Plugins/Axios';

// Frozen-shipment dashboard. When the report cannot answer it says 503 with
// `reason`; the page words that itself (see reasonOf).
export async function fetchFrozenSummary(params = {}) {
    const response = await adminAxios.get('report/frozen-shipments/summary', {params});
    return response.data.data;
}

export async function fetchFrozenBills(params = {}) {
    const response = await adminAxios.get('report/frozen-shipments/bills', {params});
    return response.data.data;
}

export function reasonOf(error) {
    const reason = error && error.response && error.response.data && error.response.data.reason;
    return ['disabled', 'busy', 'query_failed'].includes(reason) ? reason : 'generic';
}
